import React from 'react';
import ceo from "./ceo.png"
import './About.css'
const About = () => {
  return (
    <div className="container my-5 py-5">
      <div className="row align-items-center ceo-message-card " >
        <div className="col-md-4 text-center" >
          {/* CEO Picture */}
          <img 
         
            src={ceo}
            alt="CEO" 
            className="img-fluid ceo-image" 
          />
        </div>
        <div className="col-md-8">
          {/* CEO Message */}
          <h3 className="fw-bold text-dark mb-3">Guiding You Toward Excellence in <span className="text-danger">Real Estate</span></h3>
          <p className=" para " style={{textAlign:"justify",wordSpacing:"2px"}}>
          "In an evolving market, property92.pk is aligned with real estate innovation. We continually enhance our offerings and invest in modern technologies to provide you with the best insights, tools and experiences.
          Trust is the cornerstone of our business, and at property92.pk, we work tirelessly to maintain that trust through transparency, accountability, and dedication to each client. Our commitment is to  serve you with the highest level of integrity and ensure that your real estate journey is smooth and successful."
          </p>
          <h5 className="fw-bold text-danger mt-4">Naeem Tahir <span className='text-dark'> <h6 style={{display:"inline-block"}}>  &nbsp;&nbsp;CEO</h6> </span> </h5>
          <p className="text-muted fs-5">Property92.pk</p>
        </div>
      </div>
    </div>
  );
};

export default About;
